import * as R from 'ramda'

import { ESUZ_ISSUES_TYPES_KEY } from '../constants'

const prepareEsuzIssueForWidget = (esuzIssues = [], esuzStatuses = []) => R.map((issue) => ({
  ...issue,
  status  : R.find(({ id }) => id === R.prop(`statusId`, issue), esuzStatuses),
  endDate : R.prop(`eliminationEndTimestamp`, issue),
  userId  : R.prop(`performerId`, issue),
  typeName: ESUZ_ISSUES_TYPES_KEY[R.propOr(`dataIsEmpty`, `typeKey`, issue)],
}), esuzIssues)

export default prepareEsuzIssueForWidget
